<template>
  <div
    v-if="showLoadingState === 0"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productAssetsIncluded"
    class="m-edition-product-assets-included"
  >
    <blockquote class="quote quote-products-primary quote-first">
      <p>
        <span v-if="!this.proyectos.length">
          {{ $t('mEditionProductAssetsIncludedMaps.quote.firstText') }}
        </span>
        <span v-if="!this.proyectosIncluidos.length">
          {{ $t('mEditionProductAssetsIncludedMaps.quote.secondText') }}
        </span>
        <span>
          {{ $t('mEditionProductAssetsIncludedMaps.quote.thirdText') }}
        </span>
        <span>
          {{ $t('mEditionProductAssetsIncludedMaps.quote.fourthText') }}
        </span>
      </p>
    </blockquote>
    <div class="display-flex-row-center space-between">
      <div>
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.addAll"
          element="addAll"
          :disabled="!proyectosNoIncluidos.length"
          :show-loading="requests.updateProductoProyectos.isRequested &&
          requests.updateProductoProyectos.itemLoading === 'addAll'"
          @executeMethod="executeMethod"
        />

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.removeAll"
          element="removeAll"
          :disabled="!proyectosIncluidos.length"
          :show-loading="requests.updateProductoProyectos.isRequested &&
          requests.updateProductoProyectos.itemLoading === 'removeAll'"
          @executeMethod="executeMethod"
        />
      </div>

      <AtomInputPrimary
        v-model="search"
        placeholder='Buscar'
        name="search"
        type="text"
        @input="searchMapas"
      />
    </div>
    <div
      v-if="showLoadingState2"
      key="loadingState2"
    >
      <AtomLoadingSecondary/>
    </div>
    <div
      v-else
      class="m-edition-academy-users-profile-assets margin-bottom-xxlarge"
    >
      <a
        v-for="proyecto in searchedsIncluidos"
        :key="proyecto.id"
        class="m-edition-product-assets-included-proyect"
        href="#"
        @click.prevent="executeMethod('removeOne', proyecto)"
      >
        <div class="action action-remove">
          {{ $t('mEditionProductAssetsIncludedMaps.actions.remove') }}
        </div>
        <MoleculeFeedSectionContentCardDesign2
          :element="proyecto"
          :hide-move-icon="true"
          :is-asset-included="true"
          :is-asset-included-edition="true"
          :is-asset-included-request-loading="requests.updateProductoProyectos.isRequested &&
          requests.updateProductoProyectos.itemLoading === proyecto.id"
        />
      </a>

      <a
        v-for="proyecto in searchedsNoIncluidos"
        :key="proyecto.id"
        class="m-edition-product-assets-included-proyect"
        href="#"
        @click.prevent="executeMethod('addOne', proyecto)"
      >
        <div class="action action-add">
          {{ $t('mEditionProductAssetsIncludedMaps.actions.add') }}
        </div>
        <MoleculeFeedSectionContentCardDesign2
          class="not-included"
          :element="proyecto"
          :hide-move-icon="true"
          :is-asset-included="false"
          :is-asset-included-edition="true"
          :is-asset-included-request-loading="requests.updateProductoProyectos.isRequested &&
          requests.updateProductoProyectos.itemLoading === proyecto.id"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductAssetsIncludedMaps',

  components: {
    MoleculeFeedSectionContentCardDesign2: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign2')
  },

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      buttonSecondary: {
        addAll: {
          class: 'a-button-billing-secondary margin-right-xsmall',
          component: '',
          icon: 'fas fa-check',
          method: 'executeMethod',
          text: this.$t('mEditionProductAssetsIncludedMaps.buttonSecondary.addAllText'),
          type: 'button'
        },

        removeAll: {
          class: 'a-button-danger-secondary',
          component: '',
          icon: 'fas fa-ban',
          method: 'executeMethod',
          text: this.$t('mEditionProductAssetsIncludedMaps.buttonSecondary.removeAllText'),
          type: 'button'
        }
      },

      cantidadAlumnos: 1,
      incluidosToUpdate: {},
      interval: null,
      proyectos: [],
      proyectosIncluidos: [],
      proyectosNoIncluidos: [],

      requests: {
        updateProductoProyectos: {
          itemLoading: '',
          isRequested: false
        }
      },

      search: '',
      searchedsIncluidos: [],
      searchedsNoIncluidos: [],
      showLoadingState: 0,
      showLoadingState2: true
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      if (this.$modal.methodToRun === 'updateProductoProyectos') {
        this.updateProductoProyectos(this.$modal.element.action,
          this.$modal.element.proyecto, this.$modal.element.notificar)
      }
    }
  },

  created () {
    this.incluidosToUpdate = this.element.proyectos.length ? [...this.element.proyectos] : []
    this.readProyectos()
    // this.readProductoCantidadAlumnos()
  },

  destroyed () {
    // clearInterval(this.interval)
  },

  methods: {
    executeMethod (action, proyecto = null) {
      if (this.cantidadAlumnos > 0) {
        this.$modal.showModal('MoleculeEditionProductAssetsIncludedMapsModal',
          { action: action, proyecto: proyecto, nombreProd: this.element.nombre })
      } else {
        this.updateProductoProyectos(action, proyecto)
      }
    },

    readProductoCantidadAlumnos () {
      this.$services.read('producto', 'readProductoCantidadAlumnos', {}, [this.$route.params.id])
        .then(response => {
          this.cantidadAlumnos = response.data
          if (this.cantidadAlumnos < 30 && this.interval === null) {
            this.interval = setInterval(this.readProductoCantidadAlumnos, 15000)
          } else if (this.cantidadAlumnos >= 30) {
            clearInterval(this.interval)
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readProyectos () {
      let filter = { 'academia': this.$store.getters.getAcademyData.id, 'publicado': 1, 'tipo': 1 }
      this.$services.read('proyecto', 'readProyectos', {}, [this.$store.getters.getAcademyData.id], filter)
        .then(response => {
          this.proyectos = response.data.proyectos
          this.proyectos.forEach(proyecto => {
            if (this.element.proyectos && this.element.proyectos.find(incluido => incluido === proyecto.id)) {
              this.proyectosIncluidos.push(proyecto)
            } else {
              this.proyectosNoIncluidos.push(proyecto)
            }
          })
          this.searchedsIncluidos = this.proyectosIncluidos
          this.searchedsNoIncluidos = this.proyectosNoIncluidos
          this.showLoadingState++
          this.showLoadingState2 = false
        })
        .catch(error => {
          console.log(error)
        })
    },

    setProyectosToRender (action, proyecto = null) {
      switch (action) {
        case 'addAll':
          this.proyectosIncluidos = [...this.proyectos]
          this.searchedsIncluidos = [...this.proyectos]
          this.proyectosNoIncluidos = []
          this.searchedsNoIncluidos = []
          break
        case 'addOne':
          this.proyectosIncluidos.push(proyecto)
          this.proyectosIncluidos.sort((a, b) => {
            return Date.parse(a.fecha_alta) - Date.parse(b.fecha_alta)
          })
          this.proyectosNoIncluidos.splice(this.proyectosNoIncluidos.indexOf(proyecto), 1)
          this.searchedsIncluidos = this.proyectosIncluidos
          this.searchedsNoIncluidos = this.proyectosNoIncluidos
          break
        case 'removeAll':
          this.proyectosIncluidos = []
          this.searchedsIncluidos = []
          this.proyectosNoIncluidos = [...this.proyectos]
          this.searchedsNoIncluidos = [...this.proyectos]
          break
        case 'removeOne':
          this.proyectosIncluidos.splice(this.proyectosIncluidos.indexOf(proyecto), 1)
          this.proyectosNoIncluidos.push(proyecto)
          this.proyectosNoIncluidos.sort((a, b) => {
            return Date.parse(a.fecha_alta) - Date.parse(b.fecha_alta)
          })
          this.searchedsIncluidos = this.proyectosIncluidos
          this.searchedsNoIncluidos = this.proyectosNoIncluidos
          break
      }
    },

    setProyectosToUpdate (action, proyecto = null) {
      switch (action) {
        case 'addAll':
          this.proyectos.map(proyecto => {
            if (!this.incluidosToUpdate.includes(proyecto.id)) {
              this.incluidosToUpdate.push(proyecto.id)
            }
          })
          break
        case 'addOne':
          this.incluidosToUpdate.push(proyecto.id)
          break
        case 'removeAll':
          this.proyectos.map(proyecto => {
            if (this.incluidosToUpdate.includes(proyecto.id)) {
              this.incluidosToUpdate.splice(this.incluidosToUpdate.indexOf(proyecto.id), 1)
            }
          })
          break
        case 'removeOne':
          this.incluidosToUpdate.splice(this.incluidosToUpdate.indexOf(proyecto.id), 1)
          break
      }
    },

    searchMapas () {
      if (!this.showLoadingState2) {
        if (this.search) {
          this.searchedsIncluidos = this.proyectosIncluidos.filter(e => e.titulo.toLowerCase().match(this.search.toLowerCase()))
          this.searchedsNoIncluidos = this.proyectosNoIncluidos.filter(e => e.titulo.toLowerCase().match(this.search.toLowerCase()))
        } else {
          this.proyectos = []
          this.proyectosIncluidos = []
          this.proyectosNoIncluidos = []
          this.showLoadingState2 = true
          this.readProyectos()
        }
      }
    },

    updateProductoProyectos (action, proyecto = null, notificar = 0) {
      if (!this.requests.updateProductoProyectos.isRequested) {
        this.setProyectosToUpdate(action, proyecto)
        this.requests.updateProductoProyectos.isRequested = true
        this.requests.updateProductoProyectos.itemLoading = proyecto && proyecto.id ? proyecto.id : action
        Array.from(document.getElementsByClassName('action')).forEach(element => { element.style.visibility = 'hidden' })
        this.$services.update('producto', 'updateProductoProyectos', { notificar: notificar, proyectos: this.incluidosToUpdate }, [this.$route.params.id])
          .then(response => {
            this.$modal.closeModal()
            this.$modal.updateData('readElement')
            this.$alerts.pushAlert('mEditionProductAssetsIncludedMaps', 'updateProductoProyectos', 'success')
            this.setProyectosToRender(action, proyecto)
            this.requests.updateProductoProyectos.isRequested = false
            Array.from(document.getElementsByClassName('action')).forEach(element => { element.style.visibility = 'visible' })
          })
          .catch(error => {
            console.log(error)
            this.incluidosToUpdate = this.element.proyectos.length ? [...this.element.proyectos] : []
            this.$alerts.pushAlert('mEditionProductAssetsIncludedMaps', 'updateProductoProyectos', 'error', 'a-alert-danger')
            this.requests.updateProductoProyectos.isRequested = false
            Array.from(document.getElementsByClassName('action')).forEach(element => { element.style.visibility = 'visible' })
          })
      }
    }
  }
}
</script>
